import { Deserializable } from '../protocols/deserializable';
import { SubmissionStatusIdEnum } from '../enum/shared/submission-status-id.enum';

export class PaymentMethodSubmissionUsage implements Deserializable {
  public submissionId!: number;
  public idPrefix!: string;
  public idSuffix!: string;
  public submissionTypeName!: string;
  public statusId!: SubmissionStatusIdEnum;
  public submittedDate!: string | null;

  onDeserialize(): void {}
}
